import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import Img from 'gatsby-image'

const Image = ({ queryName, alt, imgClassName }) => {
  const consulta = useStaticQuery(graphql`
    query {

      integracionHead: file(relativePath: { eq: "integracion.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1600) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      parksHead: file(relativePath: { eq: "parques-head.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1600) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      investigationHead: file(relativePath: { eq: "investigacion.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1600) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      investigationParqueEolico: file(relativePath: { eq: "parque-eolico.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      investigationPlantaBiomasa: file(relativePath: { eq: "planta-biomasa.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      investigationBiocombustible: file(relativePath: { eq: "biocombustible.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      integracionFotovoltaica: file(relativePath: { eq: "energia-fotovoltaica.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      integracionTermica: file(relativePath: { eq: "energia-solar-termica.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      recargasHead: file(relativePath: { eq: "recargas-primary.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1600) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      rechargesFuncionamiento: file(relativePath: { eq: "principio-funcionamiento.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      coolingHead: file(relativePath: { eq: "solar-cooling.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1600) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      coolingSecondary: file(relativePath: { eq: "solar-cooling-2.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      hydrogenHead: file(relativePath: { eq: "hidrogeno-head.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1600) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      contactHead: file(relativePath: { eq: "contacto.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1600) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

    }
  `)

  const fluid = consulta[queryName].childImageSharp.fluid

  return (
    <Img fluid={fluid} alt={alt} className={imgClassName} style={{ height: '100%' }} />
  )
  
}

export default Image;